import axios from "axios";
import {
  fetchStaffStart,
  fetchStaffSuccess,
  fetchStaffFailure,
  addStaffStart,
  addStaffSuccess,
  addStaffFailure,
  deleteStaffStart,
  deleteStaffSuccess,
  deleteStaffFailure,
  updateStaffStart,
  updateStaffSuccess,
  updateStaffFailure,
  fetchDesignationsStart,
  fetchDesignationsSuccess,
  fetchDesignationsFailure,
} from "../slicer/staffSlice";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
// Fetch staff members
export const fetchStaff = () => async (dispatch) => {
  dispatch(fetchStaffStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getAcademicStaff`,
      getAuthHeaders() // Added authentication headers
    );
    console.log(response.data); // Log the response to see the data
    dispatch(fetchStaffSuccess(response.data.data));
  } catch (error) {
    dispatch(
      fetchStaffFailure(
        error.response?.data?.message || "Failed to fetch staff members"
      )
    );
  }
};

// Add a new staff member
export const addStaff = (staffInfo) => async (dispatch) => {
  dispatch(addStaffStart());
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/addAcademicStaff`,
      staffInfo,
      { headers } // Passed the combined headers object
    );
    dispatch(addStaffSuccess(response.data.data));
  } catch (error) {
    dispatch(
      addStaffFailure(
        error.response?.data?.message || "Failed to add staff member"
      )
    );
  }
};

// Delete a staff member
export const deleteStaff = (id) => async (dispatch) => {
  dispatch(deleteStaffStart());
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/deleteAcademicStaff/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(deleteStaffSuccess(id));
  } catch (error) {
    dispatch(
      deleteStaffFailure(
        error.response?.data?.message || "Failed to delete staff member"
      )
    );
  }
};

// Update staff member
export const updateStaff = (staffInfo,id) => async (dispatch) => {
    dispatch(updateStaffStart());
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/academicPage/updateAcademicStaff/${id}`,
        staffInfo,
        getAuthHeaders() // Added authentication headers
      );
      dispatch(updateStaffSuccess(response.data.data));
    } catch (error) {
      dispatch(updateStaffFailure(error.response?.data?.message || "Failed to update staff member"));
    }
  };

  export const fetchDesignations = () => async (dispatch) => {
    dispatch(fetchDesignationsStart());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/academicPage/getAcademicStaffDesignation`,
        getAuthHeaders() // Added authentication headers
      );
     // console.log("API Response:", response.data); // Confirm structure
      dispatch(fetchDesignationsSuccess(response.data.data || response.data)); // Adjust as needed
    } catch (error) {
      console.error("Error fetching designations:", error);
      dispatch(
        fetchDesignationsFailure(
          error.response?.data?.message || "Failed to fetch designations"
        )
      );
    }
  };